import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { getHealth, nextAction } from '../../utils/platformKpi';
import { HEALTH_COLORS, Section } from './common';

const RANK = { red: 0, amber: 1 };
const PREVIEW = 8;

/** Red then amber centers, each with its reason and one next action (design §3.8). */
const AttentionList = ({ centers, source, onOpen, sx }) => {
  const [showAll, setShowAll] = useState(false);
  const rows = centers
    .map((c) => ({ c, health: getHealth(c) }))
    .filter((r) => r.health.level !== 'green')
    .sort((a, b) => RANK[a.health.level] - RANK[b.health.level] || a.c.name.localeCompare(b.c.name));
  const visible = showAll ? rows : rows.slice(0, PREVIEW);

  return (
    <Section
      title={`Act now (${rows.length})`}
      source={source}
      sx={sx}
      action={rows.length > PREVIEW && (
        <Button size="small" onClick={() => setShowAll((v) => !v)} sx={{ textTransform: 'none', fontSize: '0.75rem' }}>
          {showAll ? 'Show less' : `Show all ${rows.length}`}
        </Button>
      )}
    >
      {rows.length === 0 && (
        <Typography sx={{ fontSize: '0.8125rem', color: 'text.secondary' }}>Every center looks healthy.</Typography>
      )}
      {visible.map(({ c, health }) => (
        <Box
          key={c.id}
          onClick={() => onOpen(c)}
          sx={{
            display: 'flex', alignItems: 'flex-start', gap: 1, py: 0.75, px: 0.5,
            borderBottom: 1, borderColor: 'divider', cursor: 'pointer',
            '&:hover': { bgcolor: 'action.hover' }, '&:last-of-type': { borderBottom: 0 },
          }}
        >
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', mt: 0.7, flexShrink: 0, bgcolor: HEALTH_COLORS[health.level] }} />
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography data-testid="attention-name" sx={{ fontSize: '0.8125rem', fontWeight: 600 }} noWrap>{c.name}</Typography>
            <Typography sx={{ fontSize: '0.72rem', color: 'text.secondary' }}>{health.reasons[0]}</Typography>
          </Box>
          <Typography sx={{ fontSize: '0.72rem', color: 'primary.main', fontWeight: 600, textAlign: 'right', maxWidth: '45%' }}>
            {nextAction(c)}
          </Typography>
        </Box>
      ))}
    </Section>
  );
};

export default AttentionList;
